var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TheHeader"},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"alt":""}}),_c('h1',[_vm._v("administration - "),_c('span',{staticClass:"TheHeader__logout",on:{"click":_vm.logout}},[_vm._v("déconnexion")])])])}
var staticRenderFns = []

export { render, staticRenderFns }